<template>
  <div class="prize-wheel">
    <div
      class="zp-main"
      :style="{ transform: transform, transition: transition }"
    >
      <!-- background: `${
            index % 2 === 0 ? colorItem.color1 : colorItem.color2
          }`, -->
      <!-- <div
        class="zp-item"
        :style="{
          transform: `rotate(${rotate * index}deg) skewY(${rotate - 90}deg)`,
        }"
        v-for="(item, index) in prizeList"
        :key="index"
      ></div> -->
      <div
        class="prizeName"
        :style="{
          transform: `rotate(-${rotate * index + rotate / 2}deg)`,
        }"
        v-for="(item, index) in prizeList"
        :key="'prizeName' + index"
      >
        <!-- color: `${index % 2 === 0 ? colorItem.color3 : colorItem.color4}`, -->
        <div
          :class="[
            {
              'prize-content': item.img,
              'noicon-prize-content': !item.img,
            },
            'common-prize-content',
          ]"
        >
          <span :class="item.name.length > 8 ? 'miniSize' : ''">{{
            item.name
          }}</span>
          <div class="item-img-wrap" v-show="item.img">
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    colorItem: {
      type: Object,
      default: () => ({
        color1: "#fdf3aa",
        color2: "#f1d5b1",
        color3: "#b57640",
        color4: "#ff302e",
      }),
    },
    prizeList: {
      type: Array,
    },
    transform: {
      type: String,
      default: "",
    },
    transition: {
      type: String,
      default: "",
    },
  },
  watch: {
    prizeList: function (val) {
      let rotate = 360 / val.length;
      this.rotate = rotate;
    },
  },
  data() {
    return {
      rotate: 0, //每个奖品度数
    };
  },
  created() {
    let rotate = 360 / this.prizeList.length;
    this.rotate = rotate;
  },
  methods: {},
};
</script>
<style lang="stylus" scoped>
.prize-wheel {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
}

img {
  width: 100%;
  height: 100%;
}

.zp-main {
  width: 100%;
  height: 100%;
  list-style: none;
  overflow: hidden;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  transform: rotate(337.5deg);
}

.zp-item {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
  // border-bottom: solid 1px #aaa;
}

.prizeName {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  text-align: center;

  .noicon-prize-content {
    height: 37%;
    position: absolute;
    justify-content: center;
    flex-direction: column;
    margin-top: -2%;
  }

  .prize-content {
    height: 50%;
  }

  .common-prize-content {
    width: 50%;
    top: -16px;
    left: 25%;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color:#BC5F5F

    .item-img-wrap {
      width: 48px;
      height: 48px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    span {
      display: block;
      width: 80px;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 20px;
      line-height: 20px;
      white-space: nowrap;
    }

    .miniSize {
      font-size: 10px;
    }
  }
}
</style>
